import React from 'react';
import { C } from '../../theme';

export const TOOL_ACCENT: Record<string, { border: string; background: string; color: string }> = {
  red:    { border: `1px solid rgba(248,113,113,0.7)`, background: C.toolEraseBg,    color: C.toolErase  },
  yellow: { border: `1px solid ${C.toolStamp}`,        background: C.toolStampBg,    color: C.toolStamp  },
  blue:   { border: `1px solid ${C.toolDraw}`,         background: C.toolDrawBg,     color: C.toolDraw   },
  green:  { border: `1px solid ${C.toolFill}`,         background: C.toolFillBg,     color: C.toolFill   },
  purple: { border: `1px solid ${C.toolText}`,         background: C.toolTextBg,     color: C.toolText   },
  cyan:   { border: `1px solid ${C.toolBlur}`,         background: C.toolBlurBg,     color: C.toolBlur   },
  '':     { border: `1px solid ${C.border}`,           background: C.toolDrawSubtle, color: C.textPrimary },
};

export const ACTION_ACCENT: Record<string, { border: string; background: string; color: string }> = {
  red:    { border: `1px solid rgba(248,113,113,0.8)`, background: `rgba(255,77,79,0.38)`,   color: C.toolEraseFg },
  yellow: { border: `1px solid rgba(245,166,35,0.8)`,  background: `rgba(245,166,35,0.38)`,  color: C.toolStampFg },
  blue:   { border: `1px solid rgba(88,166,255,0.8)`,  background: `rgba(88,166,255,0.38)`,  color: C.toolDrawFg  },
  green:  { border: `1px solid rgba(74,222,128,0.8)`,  background: `rgba(74,222,128,0.38)`,  color: C.toolFillFg  },
  purple: { border: `1px solid rgba(167,139,250,0.8)`, background: `rgba(167,139,250,0.38)`, color: C.toolTextFg  },
};

export const toolBtn = (active: boolean, accent?: 'red' | 'yellow' | 'blue' | 'green' | 'purple' | 'cyan'): React.CSSProperties => {
  const as = active ? (TOOL_ACCENT[accent ?? ''] ?? TOOL_ACCENT['']) : null;
  return {
    fontSize: 11,
    padding: '2px 8px',
    cursor: 'pointer',
    borderRadius: 3,
    border:      as?.border     ?? `1px solid ${C.border}`,
    background:  as?.background ?? 'transparent',
    color:       as?.color      ?? C.textSecondary,
    lineHeight: '18px',
    flexShrink: 0,
  };
};

/** Action button — one-shot (never toggled): always shows accent border/bg. */
export const actionBtn = (accent: 'red' | 'yellow' | 'blue' | 'green' | 'purple'): React.CSSProperties => ({
  fontSize: 11,
  padding: '2px 8px',
  cursor: 'pointer',
  borderRadius: 999,
  ...ACTION_ACCENT[accent],
  lineHeight: '18px',
  flexShrink: 0,
});

export const sep: React.CSSProperties = {
  width: 1,
  alignSelf: 'stretch',
  background: C.border,
  margin: '0 4px',
  flexShrink: 0,
};

export const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '0 8px',
  background: C.bgBase,
  borderBottom: `1px solid ${C.border}`,
  flexShrink: 0,
};
